/**
 * Input component following Tenant Nexus UI style guide
 */

import React, { InputHTMLAttributes, forwardRef } from 'react';
import { cn } from '@/utils';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  required?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, helperText, required, className, id, ...props }, ref) => {
    const inputId = id || `input-${Math.random().toString(36).substr(2, 9)}`;
    
    return (
      <div className="access-form-item">
        {label && (
          <label
            htmlFor={inputId}
            className={cn(
              'access-label',
              required && 'access-required'
            )}
          >
            {label}
          </label>
        )}
        <input
          ref={ref}
          id={inputId}
          className={cn(
            'access-input',
            error && 'access-error',
            className
          )}
          {...props}
        />
        {error && (
          <p className="access-form-error">{error}</p>
        )}
        {helperText && !error && (
          <p className="access-form-helper">{helperText}</p>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';
